import Vue from 'vue'

const urls = {
  login: `/carepro-id/login`,
  deviceRegister: `/id.reg/device/register`,
  repairRegister: `/customer-repair/`,
  repairRegisterSerial: `/customer-repair/register/device/serial`,
  repairRegisterNoSerial: `/customer-repair/register/device/type`,
  repairRegisterDefect: `/customer-repair/register`,
  repairRegisterId: `/customer-repair/register/id`,
  mypage: `/carepro-id/mypage`,
  mailverificationResend: `/carepro-id/auth/authentication/send`,
  passwordReset: `/carepro-id/auth/password-reset`,
  mailReset: `/carepro-id/auth/mail-reset`,
  accountCreate: `/carepro-id/account/create`,
  accountEdit: `/carepro-id/account/edit`,
  emailReset: `/carepro-id/auth/mail-reset`,
  mailvarificationAction: `/carepro-id/action/authentication`,
  passwordResetAction: `/carepro-id/action/password-reset`,
  device: `/carepro-id/device`,
  repair: `/carepro-id/repair`,
  kintoneOutage: `/carepro-id/outage`,
  importUserInfoResend: `/carepro-id/import-user/send`,
  salonRepair:
    'https://www.carepro-hairmedication.com/support/contact/customer-contact/',
  deviceEdit: `/carepro-id/device/edit`,
}
type Urls = typeof urls
declare module 'vue/types/vue' {
  interface Vue {
    $urls: Urls
  }
}

Vue.prototype.$urls = urls

export default urls
